<template>
  <v-navigation-drawer
    class="side-menu"
    right
    disable-resize-watcher
    light
    persistent
    absolute
    hide-overlay
    floating
    :value="menu"
    width="350"
    @input="$emit('update:menu', $event)"
  >
    <p class="title mb-0 px-3 py-4">Mais filtros</p>
    <v-divider />

    <v-container fluid>
      <v-layout row wrap class="pa-4">
        <v-flex xs12>
          <mf-select-units-dialog
            outlined
            required
            label="Lojas"
            :selected-units.sync="unidades"
            :selected-units-configuration.sync="unitsConfiguration"
            check-all-units-on-init
            :units="units"
            :tag-list="tagList"
            :group-list="unitsGroups"
            enable-inactive-units-selection
            hide-ecommerce-configuration
          />
        </v-flex>

        <v-flex xs12>
          <label>Tipo de pessoa</label>
          <v-checkbox v-model="tipoPessoa" :disabled="tipoPessoa.length === 1 && tipoPessoa[0] === 'F'" label="Física" color="primary" value="F" hide-details />
          <v-checkbox
            v-model="tipoPessoa"
            :disabled="tipoPessoa.length === 1 && tipoPessoa[0] === 'J'"
            label="Jurídica"
            color="primary"
            value="J"
            hide-details
          />
        </v-flex>

        <v-flex xs12 class="mt-6">
          <label>Clube</label>
          <v-checkbox v-model="clube" :disabled="clube.length === 1 && clube[0] === '1'" label="Sim" color="primary" value="1" hide-details />
          <v-checkbox v-model="clube" :disabled="clube.length === 1 && clube[0] === '0'" label="Não" color="primary" value="0" hide-details />
        </v-flex>
      </v-layout>
      <mf-action-buttons
        :primary-button="{
          text: 'Filtrar clientes',
          action: () => $emit('filtrar'),
          isVisible: true,
        }"
        :cancel-button="{
          text: 'Limpar',
          action: clearFilters,
          isVisible: true,
        }"
      />
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    menu: Boolean,
    filterLojas: [String, Array],
    filterUnitsConfiguration: {
      type: Array,
      default: () => [],
    },
    filterPessoa: [String, Array],
    filterCliente: [String, Array],
    filterClube: [String, Array],
  },
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    unidades: {
      get() {
        return this.filterLojas
      },
      set(value) {
        this.$emit('update:filterLojas', value)
      },
    },
    unitsConfiguration: {
      get() {
        return this.filterUnitsConfiguration
      },
      set(value) {
        this.$emit('update:filterUnitsConfiguration', value)
      },
    },
    tipoPessoa: {
      get() {
        return this.filterPessoa
      },
      set(value) {
        this.$emit('update:filterPessoa', value)
      },
    },
    tipoCliente: {
      get() {
        return this.filterCliente
      },
      set(value) {
        this.$emit('update:filterCliente', value)
      },
    },
    clube: {
      get() {
        return this.filterClube
      },
      set(value) {
        this.$emit('update:filterClube', value)
      },
    },
  },
  methods: {
    clearFilters() {
      this.$emit('update:filterClube', ['1', '0'])
      this.$emit(
        'update:filterLojas',
        this.units.map((unit) => unit.id_erp)
      )
      this.$emit('update:filterPessoa', ['F', 'J'])
      this.$emit('update:filterCliente', [])
      this.$emit('filtrar')
    },
  },
}
</script>
